import { environment } from '../../environments/environment';
import { RESOURCES } from '../core/resources';

export class Invoice {
  id: number;
  invoice_no: string;
  due_date: string;  // ISO 8601 date format
  amount: number;
  currency: string;

  constructor(opts?: Invoice) {
    Object.assign(this as Object, opts || {});
  }

  get url(): string {
    return environment.autServer + RESOURCES.invoice_pdf.replace(':id', this.id.toString());
  }

  set url(value: string) {
  }
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/model/invoice.ts